// パートナー招待URL(?partner_ref=CODE)経由の帰属コードに関する共有定数。
//
// SignupPage が URL の partner_ref を localStorage に退避し、
// CompanyOnboardingPage がオンボーディング完了時に送信・招待コード欄への
// プリフィルに用いる。両ページで storage key と検証 regex を重複定義しない
// ように、依存を持たないリーフモジュールへ切り出している（循環 import 回避）。
export const PARTNER_REF_STORAGE_KEY = 'tasky_partner_ref';
export const PARTNER_REF_REGEX = /^[A-Za-z0-9_-]{1,64}$/;

// 延長トライアル付き招待URL(?partner_ref=CODE&trial_days=14)で指定される日数。
// partner_ref と同じく localStorage に退避し、オンボーディング完了時に同送する。
// 実際に延長してよいかはサーバー側がポータルのパートナー設定（許可トライアル
// 期間）へ照会して決めるため、ここでの検証は形式チェックにとどめる。
export const PARTNER_TRIAL_DAYS_STORAGE_KEY = 'tasky_partner_trial_days';
export const PARTNER_TRIAL_DAYS_OPTIONS = [7, 14, 30] as const;

/** 招待URL・localStorage の値を許可された日数へ正規化する（不正値は null）。 */
export const parsePartnerTrialDays = (value: string | null): number | null => {
  if (!value) return null;
  const days = Number(value);
  return (PARTNER_TRIAL_DAYS_OPTIONS as readonly number[]).includes(days)
    ? days
    : null;
};
